module.exports = __webpack_public_path__ + "media/src/admin/images/favicon-f22958dd2ff090a80e59acb66f32a1a6.png";